import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { toast } from 'react-toastify';

import { extrairMensagemErro } from '~/Utils/Helpers';
import { monitoraFinalizar } from '~/Services/Service';

const schemaFinalizacao = Yup.object({
  observacao: Yup.string().max(500, 'Máximo 500 caracteres'),
});

const ModalFinalizarProcesso = ({
  show,
  boleto,
  mapa1,
  mapa2,
  onHide,
  onSucesso,
}) => {
  const [enviando, setEnviando] = useState(false);

  const handleSubmit = (values, { setSubmitting }) => {
    setEnviando(true);
    monitoraFinalizar({
      boleto,
      observacao: values.observacao || '',
    })
      .then(() => {
        toast.success('Registros lançados com sucesso.');
        if (onSucesso) onSucesso();
      })
      .catch((err) => {
        toast.error(extrairMensagemErro(err));
      })
      .finally(() => {
        setEnviando(false);
        setSubmitting(false);
      });
  };

  return (
    <Modal show={show} size="sm" onHide={onHide} backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: '1rem' }}>
          Bol.: {boleto} — QD:{mapa1 || '-'}/LT:{mapa2 || '-'}
        </Modal.Title>
      </Modal.Header>
      <Formik
        initialValues={{ observacao: '' }}
        validationSchema={schemaFinalizacao}
        onSubmit={handleSubmit}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit: formikSubmit,
          isSubmitting,
        }) => (
          <Form noValidate onSubmit={formikSubmit}>
            <Modal.Body>
              <Form.Group>
                <Form.Label className="small mb-1">Observação</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={4}
                  name="observacao"
                  value={values.observacao}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  maxLength={500}
                  isInvalid={touched.observacao && !!errors.observacao}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.observacao}
                </Form.Control.Feedback>
                <Form.Text className="text-muted">
                  {values.observacao ? values.observacao.length : 0}/500
                </Form.Text>
              </Form.Group>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                size="sm"
                onClick={onHide}
                disabled={isSubmitting || enviando}
              >
                Cancelar
              </Button>
              <Button
                variant="primary"
                size="sm"
                type="submit"
                disabled={isSubmitting || enviando}
              >
                {enviando ? 'Salvando...' : 'OK'}
              </Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default ModalFinalizarProcesso;
